import {Address} from "./Address";
export class Client {
	id: number;
	lastName: string;
	firstName: string;
	tel: string;
	address: Address;
	email: string;
}


// WEBPACK FOOTER //
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/src/app/model/Client.ts